import styles from '../styles/LoadReviews.module.css';
import LoadingIndicator from './LoadingIndicator';
import { useQuery } from '@apollo/client';
import { FetchAuditQuery } from '../queries';
import { UpdateStepWithData } from '../types';

type Props = {
  onNext: UpdateStepWithData;
  jobId: string;
};

const LoadReviews = ({ onNext, jobId }: Props) => {
  const { error, stopPolling } = useQuery(FetchAuditQuery, {
    variables: {
      jobId,
    },
    pollInterval: 1000,
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      if (data?.fetchAudit?.state === 'complete') {
        stopPolling();
        onNext(
          {
            auditSources: data?.fetchAudit?.auditSources,
          },
          2
        );
      }
    },
  });

  if (error) return <p>Error! ${error.message}</p>;

  return (
    <div className={styles.loadReviews}>
      <h2>We are searching the Internet for online reviews</h2>
      <p>This could take 30 seconds or more...</p>
      <LoadingIndicator className={styles.loadingIndicator} />
    </div>
  );
};

export default LoadReviews;
